import React, { useState } from 'react'
import Breadcrumb from '../components/Breadcrumb'
import DeveloperStartsFrom from '../components/DeveloperStartsFrom';
import NewsDetailsSec from '../sections/newsDetails/NewsDetailsSec';

import AOS from "aos"; // Import AOS library
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import { useParams } from 'react-router-dom';
import CustomHelmet from '../components/CustomHelmet';
import { t } from 'i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import NotFoundSec from '../sections/pageNotFound/NotFoundSec';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const NewsDetails = () => {
    const { idSlug } = useParams();
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    let apiUrl = process.env.REACT_APP_API_URL;
    let apiBlogDetailUrl = process.env.REACT_APP_API_URL;
    const [ourNewsSection, setOurNewsSection] = useState();
    const [newsDetailSection, setNewsDetailSection] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);


    const fetchData = async () => {
        try {
            apiUrl = `${apiUrl}${constants.homepage}?language=${language}&region_id=${countryPrefix}`;

            const res = await fetchAPI(apiUrl, "Get");
            if (res?.status === 200) {
                const section = res.data.sections;
                setOurNewsSection(section.find((item) => item.sectionId === "NewsSection"));
            }

            apiBlogDetailUrl = `${apiBlogDetailUrl}${constants.newspagedetail}?slug=${idSlug}&language=${language}&region_id=${countryPrefix}`;
            const resBlogDetail = await fetchAPI(apiBlogDetailUrl, "Get");
            if (resBlogDetail?.status === 200) {
                setNewsDetailSection(resBlogDetail?.data)
                setIsLoaded(true)
            } else {
                setLoadError(true); // set error flag
                setIsLoaded(true);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    React.useEffect(() => {
        AOS.init();

        fetchData();
    }, []);

    //const pathName = ["Home", "Our News", "News name"];
    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("news"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/news` },
        { name: newsDetailSection?.blogDetails?.title || "" },
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }

    if (loadError) {
        return (
            <NotFoundSec title={t("opps")} desc={t("news_not_found")} img={"/assets/img/not-found.svg"} cssstyle={"p-0"} />)
    }

    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Breadcrumb pathName={pathName}></Breadcrumb>
            {/* <DeveloperStartsFrom companyName={"Company Name"} location={"New Cairo, Egypt"} priceStart={"43,424,000"} ></DeveloperStartsFrom> */}
            <NewsDetailsSec ourNewsSection={ourNewsSection} newsDetailSection={newsDetailSection}></NewsDetailsSec>
        </>

    )
}

export default NewsDetails